import(/* webpackMode: "eager" */ "/app/app/[locale]/auth/login/page.tsx");
